import { render } from "./Team_adviser_en.vue?vue&type=template&id=2692888b&scoped=true"
import script from "./Team_adviser_en.vue?vue&type=script&lang=js"
export * from "./Team_adviser_en.vue?vue&type=script&lang=js"

import "./Team_adviser_en.vue?vue&type=style&index=0&id=2692888b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2692888b"

export default script